import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AllProductsTableDash.css';

const AllProductsTableDash = () => {
  const [products, setProducts] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [editedProduct, setEditedProduct] = useState({});
  const [editedCategories, setEditedCategories] = useState([]);
  const [productCategoriesMap, setProductCategoriesMap] = useState({});

  const allCategories = [
    'מערכות מולטימדיה',
    'סטריאו לרכב',
    'ניקיון וטיפוח',
    'גגונים מנשאים',
    'מוצרי חשמל למונית ולרכב',
    'טקסטיל לרכב ולמונית',
    'ריפוד למונית ולרכב',
    'אביזרים למונית ולרכב'
  ];

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get('/api/products');
      setProducts(res.data);
    } catch (error) {
      console.error('❌ שגיאה בשליפת מוצרים:', error);
    }
  };

  useEffect(() => {
    const fetchAllCategories = async () => {
      const map = {};
      for (const product of products) {
        try {
          const res = await axios.get(`/api/products/${product.id}/categories`);
          map[product.id] = res.data.categories;
        } catch (err) {
          console.error(`שגיאה בשליפת קטגוריות עבור מוצר ${product.id}:`, err);
          map[product.id] = [];
        }
      }
      setProductCategoriesMap(map);
    };

    if (products.length > 0) fetchAllCategories();
  }, [products]);

  useEffect(() => {
    if (editingProductId) {
      axios
        .get(`/api/products/${editingProductId}/categories`)
        .then(res => setEditedCategories(res.data.categories))
        .catch(err => console.error('שגיאה בשליפת קטגוריות:', err));
    }
  }, [editingProductId]);

  const handleDelete = async (id) => {
    if (!window.confirm('האם אתה בטוח שברצונך למחוק את המוצר?')) return;
    try {
      await axios.delete(`/api/products/${id}`);
      setProducts(prev => prev.filter(p => p.id !== id));
    } catch (error) {
      console.error('❌ שגיאה במחיקת מוצר:', error);
    }
  };

  const handleEditClick = (product) => {
    setEditingProductId(product.id);
    setEditedProduct({ ...product });
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(`/api/products/${editedProduct.id}`, {
        name: editedProduct.name,
        price: editedProduct.price,
        description: editedProduct.description,
        moreinfo: editedProduct.moreinfo,
        link: editedProduct.link,
      });

      await axios.post(`/api/products/${editedProduct.id}/categories`, {
        categories: editedCategories,
      });

      setEditingProductId(null);
      setEditedProduct({});
      setEditedCategories([]);
      fetchProducts();
    } catch (error) {
      console.error('❌ שגיאה בעדכון מוצר:', error);
    }
  };

  return (
    <div className="all-products-dash-container">
      <h2>רשימת כל המוצרים</h2>
      <table className="products-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>תמונה</th>
            <th>שם</th>
            <th>מחיר</th>
            <th>תיאור</th>
            <th>מידע נוסף</th>
            <th>לינק</th>
            <th>קטגוריות</th>
            <th>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => (
            <tr key={product.id}>
              <td>{product.id}</td>
              <td>
                {product.images && JSON.parse(product.images).length > 0 ? (
                  <img
                    src={JSON.parse(product.images)[0]}
                    alt={product.name}
                    style={{ width: '80px', borderRadius: '8px' }}
                  />
                ) : 'אין תמונה'}
              </td>

              {editingProductId === product.id ? (
                <>
                  <td>
                    <input
                      value={editedProduct.name}
                      onChange={(e) =>
                        setEditedProduct({ ...editedProduct, name: e.target.value })
                      }
                    />
                  </td>
                  <td>
                    <input
                      value={editedProduct.price}
                      onChange={(e) =>
                        setEditedProduct({ ...editedProduct, price: e.target.value })
                      }
                    />
                  </td>
                  <td>
                    <input
                      value={editedProduct.description}
                      onChange={(e) =>
                        setEditedProduct({ ...editedProduct, description: e.target.value })
                      }
                    />
                  </td>
                  <td>
                    <input
                      value={editedProduct.moreinfo}
                      onChange={(e) =>
                        setEditedProduct({ ...editedProduct, moreinfo: e.target.value })
                      }
                    />
                  </td>
                  <td>
                    <input
                      value={editedProduct.link}
                      onChange={(e) =>
                        setEditedProduct({ ...editedProduct, link: e.target.value })
                      }
                    />
                  </td>
                  <td>
                    {editedCategories.map((cat, index) => (
                      <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                        <select
                          value={cat}
                          onChange={(e) => {
                            const newCats = [...editedCategories];
                            newCats[index] = e.target.value;
                            setEditedCategories(newCats);
                          }}
                        >
                          <option value="">בחר קטגוריה</option>
                          {allCategories.map((c) => (
                            <option key={c} value={c}>{c}</option>
                          ))}
                        </select>
                        <button onClick={() => {
                          const newCats = [...editedCategories];
                          newCats.splice(index, 1);
                          setEditedCategories(newCats);
                        }}>❌</button>
                      </div>
                    ))}
                    <button onClick={() => setEditedCategories([...editedCategories, ''])}>
                      ➕ הוסף קטגוריה
                    </button>
                  </td>
                  <td>
                    <button className="save-btn" onClick={handleSaveEdit}>💾 שמור</button>
                    <button className="cancel-btn" onClick={() => setEditingProductId(null)}>❌ ביטול</button>
                  </td>
                </>
              ) : (
                <>
                  <td>{product.name}</td>
                  <td>{product.price} ₪</td>
                  <td>{product.description}</td>
                  <td>{product.moreinfo}</td>
                  <td>
                    {product.link ? (
                      <a href={product.link} target="_blank" rel="noopener noreferrer">
                        🔗 לינק
                      </a>
                    ) : 'אין לינק'}
                  </td>
                  <td>
                    {productCategoriesMap[product.id]?.length > 0
                      ? productCategoriesMap[product.id].join(', ')
                      : 'אין קטגוריות'}
                  </td>
                  <td>
                    <button className="edit-btn" onClick={() => handleEditClick(product)}>✏️ ערוך</button>
                    <button className="delete-btn" onClick={() => handleDelete(product.id)}>🗑️ מחק</button>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllProductsTableDash;
